import { config } from '../utils/constants/api.constants';

const {
  baseUrl,
  filter,
  appointments,
  appointmentAudit,
  uploadLink,
  submitApplications,
  releaseApplications,
} = config.api.enbdRstl;

const getAppointmentUrl = (appointmentId) =>
  `${baseUrl}${appointments}/${encodeURIComponent(appointmentId)}`;

const getAppointmentAuditUrl = (appointmentId) =>
  `${baseUrl}${appointmentAudit}/${encodeURIComponent(appointmentId)}/audit`;

export default (api) => {
  const getCreditLineListing = (payload) => {
    const url = `${baseUrl}${filter}`;
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    };
    return new Promise((resolve, reject) => {
      api
        .post(url, payload, { headers })
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  };

  const getCreditLineAppointmentDetails = (appointmentId) => {
    const url = getAppointmentUrl(appointmentId);
    return new Promise((resolve, reject) => {
      api
        .get(url)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  };

  const getCreditLineAppointmentAudit = (appointmentId, params = {}) => {
    const url = getAppointmentAuditUrl(appointmentId);
    return new Promise((resolve, reject) => {
      api
        .get(url, params)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  };

  const updateCreditLineAppointment = (appointmentId, payload) => {
    const url = getAppointmentUrl(appointmentId);
    return new Promise((resolve, reject) => {
      api
        .put(url, payload)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  };

  const getDocumentUploadLink = (payload) => {
    const url = `${baseUrl}${uploadLink}`;
    return new Promise((resolve, reject) => {
      api
        .post(url, payload)
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  };

  const uploadDocumentToPresignedUrl = async (url, file) => {
    const response = await fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': file.type || 'application/octet-stream',
      },
      body: file,
    });
    if (!response.ok) {
      throw new Error('Failed to upload document.');
    }
    return true;
  };

  const submitCreditLineApplications = (appointmentIds) => {
    const url = `${baseUrl}${submitApplications}`;
    const payload = { appointmentIds };
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    };
    return new Promise((resolve, reject) => {
      api
        .post(url, payload, { headers })
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  };

  const releaseCreditLineApplications = (appointmentIds) => {
    const url = `${baseUrl}${releaseApplications}`;
    const payload = { appointmentIds };
    const headers = {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    };
    return new Promise((resolve, reject) => {
      api
        .post(url, payload, { headers })
        .then((response) => resolve(response.data))
        .catch((error) => reject(error));
    });
  };

  return {
    getCreditLineListing,
    getCreditLineAppointmentDetails,
    getCreditLineAppointmentAudit,
    updateCreditLineAppointment,
    getDocumentUploadLink,
    uploadDocumentToPresignedUrl,
    submitCreditLineApplications,
    releaseCreditLineApplications,
  };
};
